<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">资产负债表</span>
			<span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
		</div>
		<div class="margin-right-left margin-top">
			<account-date-choose v-model="accountDate"/>
      <Button color="primary" @click="submit" class="margin-left">数据汇总</Button>
      <Button color="primary" @click="exportToExcel" :loading="loading" >导出 Excel</Button>
      <Button :loading="loading" :disabled="selectedItems.length === 0" color="red" @click="batchDelete">批量删除</Button>

		</div>
		<div class="h-panel-body">
      <Table :datas="zichanfuzhai1" :border="true" @select="handleSelectChange" :checkbox="true">
        <TableItem title="序号" :width="50">
          <template v-slot="{ index, data }">
            {{  index + 1 }}
          </template>
        </TableItem>
        <TableItem title="账套名称" prop="companyName" ></TableItem>
        <TableItem title="日期" prop="riqi" ></TableItem>
        <TableItem title="数据类型" prop="shujuleixing" ></TableItem>
        <TableItem title="库存现金" prop="h1001" ></TableItem>
        <TableItem title="银行存款" prop="h1002" ></TableItem>
        <TableItem title="应收账款" prop="h1003" ></TableItem>
        <TableItem title="其他应收款" prop="h1004" ></TableItem>
        <TableItem title="押金" prop="h100401"></TableItem>
        <TableItem title="借款" prop="h100402"></TableItem>
        <TableItem title="装修款" prop="h100403"></TableItem>
        <TableItem title="库存商品" prop="h1005"></TableItem>
        <TableItem title="低值易耗品" prop="h1006"></TableItem>
        <TableItem title="原材料" prop="h1007"></TableItem>
        <TableItem title="固定资产" prop="h1008"></TableItem>
        <TableItem title="累计折旧" prop="h1009"></TableItem>
        <TableItem title="待摊费用" prop="h1010"></TableItem>
        <TableItem title="投资损失" prop="h1011"></TableItem>
        <TableItem title="应付账款" prop="h2001"></TableItem>
        <TableItem title="应付职工薪酬" prop="h2002"></TableItem>
        <TableItem title="其他应付款" prop="h2003"></TableItem>
        <TableItem title="预提费用" prop="h2004"></TableItem>
        <TableItem title="递延收益" prop="h2005"></TableItem>
        <TableItem title="顾客定金" prop="h2006"></TableItem>
        <TableItem title="顾客欠货" prop="h2007"></TableItem>
        <TableItem title="操作" align="center" >
          <div class="actions" slot-scope="{data}">
            <span  @click="remove(data)">删除</span>
          </div>
        </TableItem>
      </Table>
		</div>
	</app-content>
</template>

<script>
 import moment from "moment";
 import {mapState} from "vuex";
 import * as XLSX from "xlsx";

 /**
	 * 资产负债表
	 */
	export default {
		name: "ZiChanFuZhai",
		data() {
			return {
        // 已选中的行数据数组
        selectedItems: [],
				quniandataList: [],
        jinniandataList: [],
				accountDate: null,
				showNumPrice: false,
				loading: false,
        quniandate: null,
        // 一级科目代码模板（根据实际需求补充完整）
        dataList:[
          {'code':'1001', 'name':'库存现金','nianchushu':null,'qichushu':null,'qimoshu':null}, //库存现金
          {'code':'1002', 'name':'银行存款','nianchushu':null,'qichushu':null,'qimoshu':null}, //银行存款
          {'code':'1003', 'name':'应收账款','nianchushu':null,'qichushu':null,'qimoshu':null}, //应收账款
          {'code':'1004', 'name':'其他应收款','nianchushu':null,'qichushu':null,'qimoshu':null}, //其他应收款
          {'code':'100401', 'name':'押金','nianchushu':null,'qichushu':null,'qimoshu':null}, //押金
          {'code':'100402', 'name':'借款','nianchushu':null,'qichushu':null,'qimoshu':null}, //借款
          {'code':'100403', 'name':'装修款','nianchushu':null,'qichushu':null,'qimoshu':null}, //装修款
          {'code':'1005', 'name':'库存商品','nianchushu':null,'qichushu':null,'qimoshu':null}, //库存商品
          {'code':'1006', 'name':'低值易耗品','nianchushu':null,'qichushu':null,'qimoshu':null}, //低值易耗品
          {'code':'1007', 'name':'原材料','nianchushu':null,'qichushu':null,'qimoshu':null}, //原材料
          {'code':'1008', 'name':'固定资产','nianchushu':null,'qichushu':null,'qimoshu':null}, //固定资产
          {'code':'1009', 'name':'累计折旧','nianchushu':null,'qichushu':null,'qimoshu':null}, //累计折旧
          {'code':'1010', 'name':'待摊费用','nianchushu':null,'qichushu':null,'qimoshu':null}, //待摊费用
          {'code':'1011', 'name':'投资损失','nianchushu':null,'qichushu':null,'qimoshu':null}, //投资损失
          {'code':'2001', 'name':'应付账款','nianchushu':null,'qichushu':null,'qimoshu':null}, //应付账款
          {'code':'2002', 'name':'应付职工薪酬','nianchushu':null,'qichushu':null,'qimoshu':null}, //应付职工薪酬
          {'code':'2003', 'name':'其他应付款','nianchushu':null,'qichushu':null,'qimoshu':null}, //其他应付款
          {'code':'2004', 'name':'预提费用','nianchushu':null,'qichushu':null,'qimoshu':null}, //预提费用
          {'code':'2005', 'name':'递延收益','nianchushu':null,'qichushu':null,'qimoshu':null}, //递延收益
          {'code':'2006', 'name':'顾客定金','nianchushu':null,'qichushu':null,'qimoshu':null}, //顾客定金
          {'code':'2007', 'name':'顾客欠货','nianchushu':null,'qichushu':null,'qimoshu':null}, //顾客欠货
        ],

        zichanfuzhai: [],
        zichanfuzhai1: [],
			}
		},
   computed: {
     ...mapState(['currentAccountSets'])
   },
		watch: {
      accountDate(newVal) {
        if (newVal) {
          // 创建日期对象
          const date = new Date(newVal);

          // 检查当前日期是否已经是1号
          if (date.getDate() !== 1) {
            // 设置为1号
            date.setDate(1);
            // 格式化为 YYYY-MM-DD
            const firstDay = date.toISOString().slice(0, 10);

            // 更新 accountDate 为每月1号
            this.$nextTick(() => {
              if (this.accountDate !== firstDay) {
                this.accountDate = firstDay;
              }
            });
          } else {
            // 如果已经是 1 号，直接加载数据
            this.loadList();
            // console.log(this.zichanfuzhai1.length);
            // if (this.zichanfuzhai1.length === 0) {
            //   this.loadListyuanshuju();
            // }
          }
        }

      },
		},
		methods: {


      remove(item) {
        this.$Confirm("确认删除?").then(() => {
          this.$api.bumenhuizong.gudingzichan.delete(item.id).then(() => {
            this.loadList();
          })
        })
      },

      batchDelete() {
        // 检查是否有选中项
        if (this.selectedItems.length === 0) {
          this.$Message.error('请选择要删除的数据！');
          return;
        }

        // 显示确认对话框，提示删除数量
        this.$Confirm(`确认要删除选中的 ${this.selectedItems.length} 条数据吗？`, '批量删除').then(() => {
          this.loading = true;
          // 提取所有选中项的 ID
          const ids = this.selectedItems.map(item => item.id);

          // 调用批量删除接口，使用 Promise.resolve 确保总是能正确处理
          //   Promise.resolve(this.$api.bumenhuizong.guanli.batchDelete(ids))
          //       .then(() => {
          //         console.log('删除成功');
          //         this.$Message.success(`成功删除 ${this.selectedItems.length} 条数据！`);
          //         this.selectedItems = [];
          //         this.loadListDian();
          //       })
          //       .catch((error) => {
          //         // 如果错误是 true，说明实际删除成功了，只是 Ajax 封装有问题
          //         if (error === true) {
          //           this.$Message.success(`成功删除 ${this.selectedItems.length} 条数据！`);
          //           this.selectedItems = [];
          //           this.loadListDian();
          //         } else {
          //           this.$Message.error('批量删除失败，请重试！');
          //         }
          //       })
          //       .finally(() => {
          //         this.loading1 = false;
          //       });
          // }).catch(() => {
          //   // 用户点击取消按钮，不做任何处理
          //   this.loading1 = false;
          // });
          this.$api.bumenhuizong.gudingzichan.batchDelete(ids).then(() => {
            this.$Message.success(`成功删除 ${this.selectedItems.length} 条数据！`);
            this.selectedItems = [];
            this.loadList();
          }).catch(() => {
            this.$Message.error('批量删除失败，请重试！');
          }).finally(() => {
            this.loading = false;
          });
        }).catch((error) => {
          // 处理用户取消操作，避免HeyUI的cancel错误
          if (error !== 'cancel') {
            const isCancelError = error === 'cancel' || (error && error.message === 'cancel')
            if (!isCancelError) {
              console.error('确认对话框错误:', error);
            }
          }
          // 用户点击取消按钮，不做任何处理
          this.loading = false;
        })
      },


      /**
       * 提交数据
       */
      /**
       * 提交数据
       */
      async submit() {
        if (this.zichanfuzhai1.length) {
          this.$Message.error('本月数据已存在，请勿重复提交！');
        } else {
          this.zichanfuzhai = [];
          this.loading = true;

          try {
            // 等待数据加载完成
            await this.loadListyuanshujuAsync();

            // 构建资产负债表数据
            const zichanItem = {};
            zichanItem.companyName = this.currentAccountSets.companyName;
            zichanItem.accountSetsId = this.currentAccountSets.id;
            zichanItem.riqi = this.accountDate;
            zichanItem.shujuleixing = '年初数';
            this.dataList.forEach(item => {
              const fieldName = `h${item.code}`;
              zichanItem[fieldName] = item.nianchushu === 0 ? null : item.nianchushu;
            });
            this.zichanfuzhai.push(zichanItem);

            const zichanItem1 = {};
            zichanItem1.companyName = this.currentAccountSets.companyName;
            zichanItem1.accountSetsId = this.currentAccountSets.id;
            zichanItem1.riqi = this.accountDate;
            zichanItem1.shujuleixing = '期初数';
            this.dataList.forEach(item => {
              const fieldName = `h${item.code}`;
              zichanItem1[fieldName] = item.qichushu === 0 ? null : item.qichushu;
            });
            this.zichanfuzhai.push(zichanItem1);

            const zichanItem2 = {};
            zichanItem2.companyName = this.currentAccountSets.companyName;
            zichanItem2.accountSetsId = this.currentAccountSets.id;
            zichanItem2.riqi = this.accountDate;
            zichanItem2.shujuleixing = '期末数';
            this.dataList.forEach(item => {
              const fieldName = `h${item.code}`;
              zichanItem2[fieldName] = item.qimoshu === 0 ? null : item.qimoshu;
            });
            this.zichanfuzhai.push(zichanItem2);

            // 保存资产负债表数据（批量保存）
            await this.$api.bumenhuizong.gudingzichan.batchUpdate(this.zichanfuzhai);

            this.loadList();
            this.$Message.success('数据保存成功！');
            this.zichanfuzhai = [];
          } catch (error) {
            // 如果错误是 true，说明实际保存成功了，只是 Ajax 封装有问题
            if (error === true) {
              this.loadList();
              this.$Message.success('数据保存成功！');
              this.zichanfuzhai = [];
            } else {
              console.error('保存失败:', error);
              this.$Message.error('数据保存失败，请重试！');
            }
          } finally {
            this.loading = false;
          }
        }
      },


      /**
       * 处理表格行选择变化事件
       *
       * 当用户勾选或取消勾选表格行时，更新已选中项列表
       * @param {Array} checks - 当前选中的所有行数据数组
       */
      handleSelectChange(checks) {
        this.selectedItems = checks;
      },


      /**
       * 导出 Excel
       */
      exportToExcel() {
        // 检查是否有数据可导出
        if (this.zichanfuzhai1.length === 0) {
          this.$Message.warning('没有可导出的数据');
          return;
        }

        this.loading = true;

        try {
          // 准备导出数据
          const data = this.zichanfuzhai1.map((item, index) => {
            return {
              '序号': index + 1,
              '账套名称': item.companyName || '',
              '日期': item.riqi || '',
              '数据类型': item.shujuleixing || '',
              '库存现金': item.h1001 || '',
              '银行存款': item.h1002 || '',
              '应收账款': item.h1003 || '',
              '其他应收款': item.h1004 || '',
              '押金': item.h100401 || '',
              '存款': item.h100402 || '',
              '装修款': item.h100403 || '',
              '库存商品': item.h1005 || '',
              '低值易耗品': item.h1006 || '',
              '原材料': item.h1007 || '',
              '固定资产': item.h1008 || '',
              '累计折旧': item.h1009 || '',
              '待摊费用': item.h1010 || '',
              '投资损失': item.h1011 || '',
              '应付账款': item.h2001 || '',
              '应付职工薪酬': item.h2002 || '',
              '其他应付款': item.h2003 || '',
              '预提费用': item.h2004 || '',
              '递延收益': item.h2005 || '',
              '顾客定金': item.h2006 || '',
              '顾客欠货': item.h2007 || ''
            };
          });

          // 创建工作表
          const ws = XLSX.utils.json_to_sheet(data, { skipHeader: false });

          // 设置列宽
          const wscols = [
            {wch: 5},   // 序号
            {wch: 20},  // 账套名称
            {wch: 12},  // 日期
            {wch: 10},  // 数据类型
            {wch: 12},  // 库存现金
            {wch: 12},  // 银行存款
            {wch: 12},  // 应收账款
            {wch: 12},  // 其他应收款
            {wch: 10},  // 押金
            {wch: 10},  // 存款
            {wch: 10},  // 装修款
            {wch: 12},  // 库存商品
            {wch: 12},  // 低值易耗品
            {wch: 10},  // 原材料
            {wch: 12},  // 固定资产
            {wch: 12},  // 累计折旧
            {wch: 12},  // 待摊费用
            {wch: 12},  // 投资损失
            {wch: 12},  // 应付账款
            {wch: 12},  // 应付职工薪酬
            {wch: 12},  // 其他应付款
            {wch: 12},  // 预提费用
            {wch: 12},  // 递延收益
            {wch: 12},  // 顾客定金
            {wch: 12}   // 顾客欠货
          ];
          ws['!cols'] = wscols;

          // 创建工作簿
          const wb = XLSX.utils.book_new();

          // 获取当前日期作为文件名的一部分
          const fileNameDate = this.accountDate ? moment(this.accountDate).format('YYYY-MM') : moment().format('YYYY-MM');
          XLSX.utils.book_append_sheet(wb, ws, `资产负债表${fileNameDate}`);

          // 导出文件
          const fileName = `资产负债表_${fileNameDate}.xlsx`;
          XLSX.writeFile(wb, fileName);

          // 显示成功提示
          this.$Message.success(`数据导出成功，文件名：${fileName}`);
        } catch (error) {
          console.error('导出失败:', error);
          this.$Message.error('导出失败，请重试');
        } finally {
          this.loading = false;
        }
      },


      /**
       * 加载原始数据（返回 Promise）
       */
      loadListyuanshujuAsync() {
        // 获取账套开始年份
        const enableDateYear = moment(this.currentAccountSets.enableDate).format('YYYY');
        //获取当前会计年份
        const accountDateYear = moment(this.accountDate).format('YYYY');

        const danqiandate = moment(this.accountDate).endOf('month').format('YYYY-MM-DD');

        if (enableDateYear < accountDateYear) {
          this.quniandate = moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
        }

        // 并行加载去年和今年数据
        return Promise.all([
          // 加载去年数据（如果需要）
          enableDateYear < accountDateYear
              ? this.$api.accountbook.loadSubjectBalance({
                accountDate: this.quniandate,
                showNumPrice: this.showNumPrice
              })
              : Promise.resolve({ data: [] }),

          // 加载今年数据
          this.$api.accountbook.loadSubjectBalance({
            accountDate: danqiandate,
            showNumPrice: this.showNumPrice
          })
        ])
            .then(([lastYearRes, currentYearRes]) => {
              this.quniandataList = lastYearRes.data || [];
              this.jinniandataList = currentYearRes.data || [];

              // 合并数据
              // 根据 dataList 的 code 值，填充年初数、期初数、期末数
              this.dataList = this.dataList.map(item => {
                // 从去年数据中查找（年初数）
                const lastYearItem = this.quniandataList.find(data => data.code === item.code);
                // 从今年数据中查找（期初数和期末数）
                const currentYearItem = this.jinniandataList.find(data => data.code === item.code);

                return {
                  ...item, // 保留原有的 code 和 name
                  // 年初数 = 去年年末余额（0 转为 null）
                  nianchushu: lastYearItem ? (lastYearItem.endingBalance === 0 ? null : lastYearItem.endingBalance) : null,
                  // 期初数 = 今年年初余额（0 转为 null）
                  qichushu: currentYearItem ? (currentYearItem.beginningBalance === 0 ? null : currentYearItem.beginningBalance) : null,
                  // 期末数 = 今年年末余额（0 转为 null）
                  qimoshu: currentYearItem ? (currentYearItem.endingBalance === 0 ? null : currentYearItem.endingBalance) : null
                };
              });

            })
            .catch((error) => {
              console.error('加载数据失败:', error);
              this.$Message.error('加载资产负债表数据失败');
              throw error; // 重新抛出错误
            });
      },

      loadList() {
        if (!this.accountDate) {
          console.warn('accountDate 为空，不加载数据');
          return;
        }

        this.$api.bumenhuizong.gudingzichan.list(this.accountDate)
            .then(({data}) => {
              this.zichanfuzhai1 = data;
            })
            .catch((error) => {
              console.error('加载资产负债表失败:', error);
              // 不显示错误提示，因为可能是正常情况（没有数据）
            });

      },
		},
   mounted() {
     // this.loadList()
   }
	}
</script>

<style scoped lang="less">
	.h-panel-bar {
		display: flex; /* 使用 Flexbox 布局 */
		justify-content: space-between; /* 让子元素两端对齐 */
		align-items: center; /* 垂直居中对齐 */
	}
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
